import React, { useRef, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getAccessToken } from '../../../shared/utils/accessTokenStore';
import { WEBSITE_BASE_URL } from '../../shared/api';
import { WorkspaceLayout } from '../../shared/components/Layout';
import StylesForm from './components/StylesForm';

import componentStyles from './Website.module.scss';

const Website = () => {
  const iframeRef = useRef(null);

  const [enlarged, setEnlarged] = useState(false);

  const toggleEnlarged = () => {
    setEnlarged((prevEnlarged) => !prevEnlarged);
  };

  const updateWebsiteSection = ({ sectionId, sectionSettings }) => {
    const iframeWindow = iframeRef.current.contentWindow;
    const jwtToken = getAccessToken();

    const message = {
      jwtToken,
      sectionId,
      sectionSettings,
      type: 'updateSection',
    };

    iframeWindow.postMessage(message, WEBSITE_BASE_URL);
    // TODO: Handle postMessage errors.
  };

  return (
    <WorkspaceLayout>
      <div className={componentStyles.header}>
        <button
          className={`${componentStyles.toggle} ${enlarged ? componentStyles['toggle--active'] : ''}`}
          onClick={toggleEnlarged}
          type="button"
        >
          <FontAwesomeIcon icon="pencil" className={componentStyles.toggle__icon} />
          Edit Website
        </button>
      </div>

      <div className={componentStyles.container}>
        <iframe
          className={componentStyles.iframe}
          ref={iframeRef}
          src={WEBSITE_BASE_URL}
          title="Website Preview"
        />

        <StylesForm hidden={!enlarged} updateWebsiteSection={updateWebsiteSection} />
      </div>
    </WorkspaceLayout>
  );
};

export default Website;
